import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sparkles, Lightbulb, Globe, TrendingUp, CheckCircle2 } from "lucide-react";

const STAGES = [
  { icon: Sparkles, text: "Finding creative names..." },
  { icon: Lightbulb, text: "Checking naming patterns..." },
  { icon: Globe, text: "Checking domain availability..." },
  { icon: TrendingUp, text: "Estimating domain values..." },
  { icon: CheckCircle2, text: "Almost there..." },
];

export function GenerationProgress({ description }) {
  const [stage, setStage] = useState(0);
  const [pct, setPct] = useState(6);

  useEffect(() => {
    const stageTimer = setInterval(() => setStage((s) => (s < STAGES.length - 1 ? s + 1 : s)), 4200);
    const pctTimer = setInterval(() => setPct((p) => (p < 94 ? p + Math.max(1, (94 - p) * 0.06) : p)), 400);
    return () => {
      clearInterval(stageTimer);
      clearInterval(pctTimer);
    };
  }, []);

  return (
    <div className="max-w-[560px] mx-auto text-center py-10" data-testid="generation-progress">
      <div className="relative w-24 h-24 mx-auto mb-8">
        <div className="absolute inset-0 rounded-full brand-gradient opacity-20 animate-ping" style={{ animationDuration: "2.4s" }} />
        <div className="absolute inset-2 rounded-full brand-gradient flex items-center justify-center shadow-glow">
          {STAGES.map((S, i) => {
            const Icon = S.icon;
            return (
              <motion.div
                key={i}
                initial={false}
                animate={{ opacity: stage === i ? 1 : 0, scale: stage === i ? 1 : 0.6 }}
                transition={{ duration: 0.4 }}
                className="absolute text-white"
              >
                <Icon size={34} strokeWidth={2} />
              </motion.div>
            );
          })}
        </div>
      </div>

      <motion.p key={stage} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="text-[19px] font-extrabold text-ink tracking-[-0.01em]">
        {STAGES[stage].text}
      </motion.p>
      {description && (
        <p className="text-[13px] text-ink-subtle mt-2 max-w-[380px] mx-auto truncate">“{description}”</p>
      )}

      <div className="mt-7 h-2 rounded-full bg-canvas-alt overflow-hidden max-w-[340px] mx-auto">
        <motion.div
          className="h-full brand-gradient rounded-full"
          animate={{ width: `${pct}%` }}
          transition={{ ease: "easeOut", duration: 0.5 }}
        />
      </div>
      <p className="text-[12px] text-ink-subtle mt-3">This usually takes 15–60 seconds. Great names are worth the wait.</p>
    </div>
  );
}
